import { Box } from '@chakra-ui/react';
import { User } from 'api/types';
import { ContentCard } from 'layout/ContentCard';
import { useTranslation } from 'react-i18next';
import { BiError } from 'react-icons/bi';

import { ManageUserAccess } from './ManageUserAccess';

type Props = {
  user: User;
};

export function UserDangerZone({ user }: Props) {
  const { t } = useTranslation('user');

  return (
    <ContentCard backgroundColor="red.50" icon={<BiError size={40} />} header={<Box>{t('danger_zone.heading')}</Box>}>
      <ManageUserAccess user={user} />
    </ContentCard>
  );
}
